import { createAction, ActionCancelledError } from "@coverme/redux";
import Axios from "axios";

export const getCases = (customerId, query, cancellationToken) => {
    const config = cancellationToken != null ? { cancelToken: cancellationToken } : {};
    return createAction("GET_CASES", () =>
        Axios.post(`/api/customer/${customerId}/encounters/search`, query || {}, config)
            .then(res => res.data)
            .catch(thrown => {
                if (Axios.isCancel(thrown)) {
                    throw new ActionCancelledError(thrown.message);
                } else {
                    throw thrown;
                }
            })
    );
};

export const getCaseMetadata = customerId =>
    createAction("GET_ENCOUNTER_SEARCH_METADATA", () =>
        Axios.get(`/api/customer/${customerId}/encounters/search/metadata`)
            .then(res => res.data)
            .catch(thrown => {
                if (Axios.isCancel(thrown)) {
                    throw new ActionCancelledError(thrown.message);
                } else {
                    throw thrown;
                }
            })
    );

export const getCaseCounts = (customerId,query = {}) =>

    createAction("GET_CASE_COUNTS", () =>
        Axios.post("/api/customer/" + customerId + "/encounters/counts", query).then(res => res.data)
    );


export const getCaseCovermeReportingCounts = (customerId,query = {}) =>
    createAction("GET_CASE_COUNTS", () =>
        Axios.post("/api/customer/" + customerId + "/encounters/covermereportingcounts", query).then(res => res.data)
    );

export function updateCasesFilter(filter, query) {
    return {
        type: "UPDATE_CASES_FILTER",
        filter: filter,
        query: query,
    };
}

export const getPrograms = customerId =>
    createAction("GET_PROGRAMS", () => Axios.get(`/api/programs/customer/${customerId}`).then(res => res.data));
